import {
  GET_EVENTS_FAIL,
  GET_EVENTS_REQUEST,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_CANCEL,
  REMOVE_EVENT,
  UPDATE_EVENT,
} from '../actions/events';

const initialState = {
  events: [],
  eventsTotal: 0,
  eventsAllTotal: 0,
  eventsActiveTotal: 0,
  eventsBlockedTotal: 0,
  eventsLoading: false,
  eventsError: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_EVENTS_REQUEST: {
      return {
        ...state,
        eventsLoading: true,
        eventsError: false,
      };
    }
    case GET_EVENTS_SUCCESS: {
      return {
        ...state,
        events: action.payload.events,
        eventsTotal: action.payload.total,
        eventsAllTotal: state.eventsAllTotal || action.payload.total,
        eventsActiveTotal: state.eventsActiveTotal || action.payload.total_active,
        eventsBlockedTotal: state.eventsBlockedTotal || action.payload.total_blocked,
        eventsLoading: false,
        eventsError: false,
      };
    }
    case GET_EVENTS_FAIL: {
      return {
        ...state,
        eventsLoading: false,
        eventsError: true,
      };
    }
    case GET_EVENTS_CANCEL: {
      return {
        ...state,
        eventsLoading: false,
        eventsError: false,
      };
    }
    case UPDATE_EVENT: {
      const newEvents = state.events.map(
        (item) => (item._id === action.payload._id ? Object.assign(item, action.payload) : item),
      );
      return {
        ...state,
        eventsLoading: false,
        eventsError: true,
        events: newEvents,
      };
    }
    case REMOVE_EVENT: {
      const newEvents = state.events.filter((item) => item._id !== action.payload._id);
      return {
        ...state,
        eventsLoading: false,
        eventsError: true,
        events: newEvents,
      };
    }

    default: {
      return state;
    }
  }
}
